import Box from '@mui/material/Box';
import { AttendanceWidget, PerformanceWidget, QuickActionsWidget } from 'modules/shared/components';
import { EmployeeProjectList } from 'modules/work-implementation/projects-list';

export default function EmployeeHome() {
  return (
    <>
      <div className='column gap-8'>
        <QuickActionsWidget />
        {/* Side by side when there is room, stacked on a narrow screen. Each widget hides itself
            when the role lacks its screen (My Work, My Attendance). */}
        <Box sx={{ display: 'grid', gap: 4, gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 420px), 1fr))' }}>
          <PerformanceWidget />
          <AttendanceWidget />
        </Box>
      </div>

      <EmployeeProjectList />
    </>
  );
}
